import React from 'react';

export const THEME_STORAGE_KEY = 'rb-theme';

export const getStoredDarkMode = () => (
  typeof window !== 'undefined' &&
  window.localStorage.getItem(THEME_STORAGE_KEY) === 'dark'
);

export const saveTheme = (darkMode) => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(THEME_STORAGE_KEY, darkMode ? 'dark' : 'light');
  }
};

const ThemeToggle = ({ darkMode, onToggle, compact = false }) => (
  <button
    type="button"
    onClick={onToggle}
    className={`inline-flex items-center justify-center gap-2 rounded-lg border transition-colors ${
      compact ? 'w-full px-3 py-2 text-xs' : 'px-3 py-2 text-sm'
    } ${
      darkMode
        ? 'border-slate-600 bg-slate-800 text-slate-100 hover:bg-slate-700'
        : 'border-slate-300 bg-white text-slate-700 hover:border-orange-400 hover:text-orange-600'
    }`}
    aria-pressed={darkMode}
    aria-label={darkMode ? 'Aktifkan mode terang' : 'Aktifkan mode gelap'}
    title={darkMode ? 'Aktifkan mode terang' : 'Aktifkan mode gelap'}
  >
    <span aria-hidden="true">{darkMode ? '☀️' : '🌙'}</span>
    <span>{darkMode ? 'Terang' : 'Gelap'}</span>
  </button>
);

export default ThemeToggle;